import { ChangeEvent, useEffect, useState } from "react";
import { styled } from "@mui/material";
import userLogo from "../../assets/images/user.png";
import LoadingButton from "@mui/lab/LoadingButton";

export default function UploadButton({
  id,
  uploadPhoto,
  label,
  isLoading = false,
}: {
  id: string;
  label: string;
  uploadPhoto: (userId: string, image: File) => void;
  isLoading?: boolean;
}) {
  const onChangeImage = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files !== null) {
      if (e.target.files[0]) uploadPhoto(id, e.target.files[0]);
    }
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });
  return (
    <LoadingButton
      size="small"
      color="primary"
      component="label"
      role={undefined}
      variant="outlined"
      tabIndex={-1}
      loading={isLoading}
    >
      {label}
      <VisuallyHiddenInput type="file" onChange={(e) => onChangeImage(e)} />
    </LoadingButton>
  );
}
